<div class="slat-edit-modal-container">
  <div class="mat-headline-4 slat-edit-text-container">
    {{ 'Edit SLAT SUB TEST' | translate }}
  </div>
  <mat-dialog-content class="slat-edit-modal-dropdowns">
    <H1 class="slat-group-name">{{ groupName | translate }}</H1>
    <H3 class="slat-item-title">{{ name | translate }}</H3>
    <H3 *ngIf="!isCoreLanguage" class="slat-item-description">{{
      description | translate
    }}</H3>
    <app-text-input
      *ngIf="!isCoreLanguage"
      id="rawScore"
      [label]="rawScoreLabel | translate"
      [placeholder]="rawScoreLabel | translate"
      [control]="form.controls['rawScore']"
      [required]="true"
      pattern="^[0-9]*$"
      type="number"
      min="0"
      max="100"
      step="1"
      [errorText]="'range of 0-100' | translate"
    />
    <app-text-input
      id="score"
      [label]="scoreLabel | translate"
      [placeholder]="scoreLabel | translate"
      [control]="form.controls['scaledScore']"
      [required]="isCoreLanguage"
      pattern="^[0-9]*$"
      type="number"
      min="1"
      max="160"
      step="1"
      [errorText]="'range of 1-160' | translate"
    />
    <app-text-input
      id="percentileRank"
      [label]="'Percentile Rank' | translate"
      [placeholder]="'Percentile Rank' | translate"
      [control]="form.controls['percentileRank']"
      [required]="isCoreLanguage"
      type="number"
      min="0"
      max="100"
      step="0.01"
      [errorText]="'range of 0-100' | translate"
    />
    <app-dropdown
      id="levels"
      [label]="'Level' | translate"
      [control]="form.controls['level']"
      [required]="isCoreLanguage"
      [data]="levels"
      [isCustom]="true"
      [errorText]="'Selection is required' | translate"
    ></app-dropdown>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="slat-edit-modal-actions">
      <button mat-button (click)="onCancel()">
        {{ 'Cancel' | translate }}
      </button>
      <app-action-button
        (onClick)="onPrevious()"
        [isDisabled]="currentIndex === 0 || form.invalid"
        color="primary"
        kind="filled"
        size="standard"
        type="button"
      >
        {{ 'Previous' | translate }}
      </app-action-button>

      <app-action-button
        (onClick)="onNext()"
        [isDisabled]="currentIndex === items.length - 1 || form.invalid"
        color="primary"
        kind="filled"
        size="standard"
        type="button"
      >
        {{ 'Next' | translate }}
      </app-action-button>

      <app-action-button
        (onClick)="onSubmit()"
        [isDisabled]="form.invalid"
        color="primary"
        kind="filled"
        size="standard"
        type="button"
      >
        {{ 'Submit' | translate }}
      </app-action-button>
    </div>
  </mat-dialog-actions>
</div>
